import { elementOrTor } from "../../arrangement/elementFunctions";
import { useState } from "react";
import { Auswahl } from "../Auswahl";
import { Image } from "../Image";
import { I18N } from "oc-I18N";
import * as Commons from "oc-commons/Commons";
import {
  filterPathIntersectionCached,
  findPathIntersectionCached,
  sortForSortierung,
} from "oc-app/metadata/GraphMetadata";
import { Farbmenuselect } from "./Farbmenuselect";
import { MAuswahlwert } from "../../../metamodell";
import { PAuswahlwert } from "../../../metamodell_paths";
import classnames from "classnames";

export function FüllungsMenu({ fadedIn }) {
  const agt = APP.arrangement;
  const { Füllung } = agt.auswahlAccessoren;

  const füllung2DetailSerieAuswahlwertPath = (p: PAuswahlwert) =>
    elementOrTor(p.Objekt).DetailSerie.Auswahlwert;

  const detailSerien2FüllungAuswahlwerteMap = Commons.multiGroupBy(
    Füllung.möglicheAuswahlwerte,
    (füllungsAuswahlwert: MAuswahlwert) =>
      sortForSortierung(
        filterPathIntersectionCached("FüllungsMenu.tsx:26")(
          füllungsAuswahlwert,
          füllung2DetailSerieAuswahlwertPath
        ) as MAuswahlwert[]
      )
  ) as Map<MAuswahlwert, MAuswahlwert[]>;

  const alleElemente = APP.arrangement.getElemente();
  const vorkommendeFüllungAuswahlwerte = _.uniq(alleElemente.map((e) => e.füllungAuswahlwert));

  detailSerien2FüllungAuswahlwerteMap.set(
    APP.richMetadata.findAuswahlwert("VerwendeteFüllungen"),
    sortForSortierung(vorkommendeFüllungAuswahlwerte)
  );

  const detailSerienAuswahlwerte: MAuswahlwert[] = sortForSortierung(
    Array.from(detailSerien2FüllungAuswahlwerteMap.keys())
  );

  let detailSerieAuswahlwertDefault: MAuswahlwert =
    findPathIntersectionCached("FüllungsMenu.tsx:43")(
      Füllung.auswahlwert,
      füllung2DetailSerieAuswahlwertPath
    ) ?? agt.inspiration?.DetailSerie?.Auswahlwert;

  const vorkommendeDetailSerienAuswahlwerte = alleElemente
    .flatMap((e) => e.meta.DetailSerie)
    .map((e) => e.Auswahlwert);

  if (!_.includes(vorkommendeDetailSerienAuswahlwerte, detailSerieAuswahlwertDefault)) {
    detailSerieAuswahlwertDefault = Commons.maxFrequent(vorkommendeDetailSerienAuswahlwerte);
  }

  let [detailSerieAuswahlwert, setDetailSerieAuswahlwert] = useState(detailSerieAuswahlwertDefault);

  if (!detailSerien2FüllungAuswahlwerteMap.has(detailSerieAuswahlwert)) {
    detailSerieAuswahlwert = detailSerieAuswahlwertDefault;
  }

  const füllungAuswahlwerte = detailSerien2FüllungAuswahlwerteMap.get(detailSerieAuswahlwert) ?? [];

  return (
    <div
      className={classnames("fuellung-menu", !fadedIn && "page-initial-hidden")}
      data-group-key="Füllungsmenu"
      role="group"
      aria-label={I18N("aria::Füllungsmenü")}
    >
      <div className="detailserien-auswahl">
        <Auswahl
          Key="DetailSerie"
          value={detailSerieAuswahlwert}
          showHeadline={false}
          auswahlwerte={detailSerienAuswahlwerte}
          customClassPortal="detailserien-auswahl"
          customLabel={(value) => {
            return (
              <div className="dropdown-entry">
                {(!Commons.isEmpty(value.Auswahlbild) || !Commons.isEmpty(value.Thumbnail)) && (
                  <Image url={value.Thumbnail || value.Auswahlbild} />
                )}
                <div
                  className={classnames(
                    "text",
                    (!Commons.isEmpty(value.Auswahlbild) || !Commons.isEmpty(value.Thumbnail)) &&
                      "with-image"
                  )}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: Commons.isEmpty(value.Bezeichnung) ? value.Name : value.Bezeichnung,
                    }}
                  ></span>
                </div>
              </div>
            );
          }}
          onChange={(detailSerieAuswahlwert) => {
            setDetailSerieAuswahlwert(detailSerieAuswahlwert);
            APP.logUserAction(
              {
                action: "DetailSerieDropdown",
                setDetailSerie: detailSerieAuswahlwert,
              },
              { stateChange: false }
            );
          }}
        />
      </div>
      <div
        key={detailSerieAuswahlwert?.Key}
        className="füllungen"
        data-select-key="Füllung"
        data-value={APP.arrangement.füllungAuswahlwert?.Key}
        role="radiogroup"
        aria-label={I18N("aria::Füllung auswählen")}
      >
        <Farbmenuselect
          key={detailSerieAuswahlwert?.Key}
          auswahlwerte={füllungAuswahlwerte}
          value={Füllung.auswahlwert}
          onChange={(füllungAuswahlwert) => {
            Füllung.setter(füllungAuswahlwert);
          }}
          className="material-item"
        />
      </div>
    </div>
  );
}
